import React from 'react';
import {pingWebsocket} from '../actions/actionWebsocket';
import {modules} from '../constants/Utils';
import {connect} from 'react-redux';

class WebsocketHeartbeat extends React.Component {
    componentDidMount() {
        this.pingAllWebsockets();
        setInterval(this.pingAllWebsockets, 540 * 1000);
    }

    pingAllWebsockets = () => {
        const {pingWebsocket} = this.props;
        pingWebsocket(modules.SPARE_PARTS);
        pingWebsocket(modules.TECHNICAL_DOCUMENTATION);
        pingWebsocket(modules.BVM);
        pingWebsocket(modules.ADMINISTRATION);
        pingWebsocket(modules.CLAIMS);
    };

    render() {
        return (<></>);
    }
}

export default connect(null, {
    pingWebsocket
})(WebsocketHeartbeat);
